var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3965 20.625C18.2594 20.625 18.959 21.3245 18.959 22.1875V32.6045C18.9588 33.4673 18.2593 34.167 17.3965 34.167H4.89648C4.03364 34.167 3.33416 33.4673 3.33398 32.6045V22.1875C3.33398 21.3245 4.03353 20.625 4.89648 20.625H17.3965ZM35.1045 20.625C35.9674 20.625 36.667 21.3245 36.667 22.1875V32.6045C36.6668 33.4673 35.9673 34.167 35.1045 34.167H22.6045C21.7418 34.1668 21.0422 33.4672 21.042 32.6045V22.1875C21.042 21.3247 21.7417 20.6252 22.6045 20.625H35.1045ZM17.3965 5C18.2594 5 18.959 5.69954 18.959 6.5625V16.9795C18.9588 17.8423 18.2593 18.542 17.3965 18.542H4.89648C4.03364 18.542 3.33416 17.8423 3.33398 16.9795V6.5625C3.33398 5.69954 4.03353 5 4.89648 5H17.3965ZM35.1045 5C35.9674 5 36.667 5.69954 36.667 6.5625V16.9795C36.6668 17.8423 35.9673 18.542 35.1045 18.542H22.6045C21.7418 18.5418 21.0422 17.8422 21.042 16.9795V6.5625C21.042 5.69965 21.7417 5.00018 22.6045 5H35.1045Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiles);
export default __webpack_public_path__ + "static/media/tiles.8768b7d5d31a23eff68f429abb6c026e.svg";
export { ForwardRef as ReactComponent };